// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UALADSComponentIdentification
 */
export interface UALADSComponentIdentification {
    /**
     * DeviceClass indicates in which domain or for what
     * purpose a certain item for which the Interface is
     * applied is used. Examples are
     * “ProgrammableController”, “RemoteIO”, and
     * “TemperatureSensor”.
     */
    deviceClass: string;
    /**
     * DeviceManual allows specifying an address of the
     * user manual. It may be a pathname in the file
     * system or a URL (Web address).
     */
    deviceManual: string;
    /**
     * DeviceRevision provides the overall revision
     * level of a hardware component or the Device. As
     * an example, this Property can be used in ERP
     * systems together with the ProductCode Property.
     */
    deviceRevision: string;
    /**
     * 
     */
    hardwareRevision: string;
    /**
     * 
     */
    manufacturer: string;
    /**
     * 
     */
    manufacturerUri: string;
    /**
     * 
     */
    model: string;
    /**
     * 
     */
    productCode: string;
    /**
     * 
     */
    productInstanceUri: string;
    /**
     * 
     */
    revisionCounter: string;
    /**
     * 
     */
    serialNumber: string;
    /**
     * 
     */
    softwareRevision: string;
}

/**
 * Check if a given object implements the UALADSComponentIdentification interface.
 */
export function instanceOfUALADSComponentIdentification(value: object): value is UALADSComponentIdentification {
    if (!('deviceClass' in value) || value['deviceClass'] === undefined) return false;
    if (!('deviceManual' in value) || value['deviceManual'] === undefined) return false;
    if (!('deviceRevision' in value) || value['deviceRevision'] === undefined) return false;
    if (!('hardwareRevision' in value) || value['hardwareRevision'] === undefined) return false;
    if (!('manufacturer' in value) || value['manufacturer'] === undefined) return false;
    if (!('manufacturerUri' in value) || value['manufacturerUri'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('productCode' in value) || value['productCode'] === undefined) return false;
    if (!('productInstanceUri' in value) || value['productInstanceUri'] === undefined) return false;
    if (!('revisionCounter' in value) || value['revisionCounter'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('softwareRevision' in value) || value['softwareRevision'] === undefined) return false;
    return true;
}

export function UALADSComponentIdentificationFromJSON(json: any): UALADSComponentIdentification {
    return UALADSComponentIdentificationFromJSONTyped(json, false);
}

export function UALADSComponentIdentificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UALADSComponentIdentification {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceClass': json['deviceClass'],
        'deviceManual': json['deviceManual'],
        'deviceRevision': json['deviceRevision'],
        'hardwareRevision': json['hardwareRevision'],
        'manufacturer': json['manufacturer'],
        'manufacturerUri': json['manufacturerUri'],
        'model': json['model'],
        'productCode': json['productCode'],
        'productInstanceUri': json['productInstanceUri'],
        'revisionCounter': json['revisionCounter'],
        'serialNumber': json['serialNumber'],
        'softwareRevision': json['softwareRevision'],
    };
}

export function UALADSComponentIdentificationToJSON(json: any): UALADSComponentIdentification {
    return UALADSComponentIdentificationToJSONTyped(json, false);
}

export function UALADSComponentIdentificationToJSONTyped(value?: UALADSComponentIdentification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deviceClass': value['deviceClass'],
        'deviceManual': value['deviceManual'],
        'deviceRevision': value['deviceRevision'],
        'hardwareRevision': value['hardwareRevision'],
        'manufacturer': value['manufacturer'],
        'manufacturerUri': value['manufacturerUri'],
        'model': value['model'],
        'productCode': value['productCode'],
        'productInstanceUri': value['productInstanceUri'],
        'revisionCounter': value['revisionCounter'],
        'serialNumber': value['serialNumber'],
        'softwareRevision': value['softwareRevision'],
    };
}

